import { msg } from "@lingui/core/macro";
import { createRoute, useSearch } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@/components/ui/page-container";
import { ActivityFeedPage } from "@/features/activity/components/activity-feed-page";
import { useI18n } from "@/providers/i18n-provider";

/**
 * Search params del feed de actividad:
 *   - `session`: sesión de caja preseleccionada (enlace "actividad del turno"
 *     desde el cierre de caja). Solo inicializa el filtro; el cambio posterior
 *     es estado local (sin efecto URL→estado — patrón CC-16-safe).
 */
interface ActivitySearch {
  session?: string;
}

function ActivityRoutePage() {
  const { t } = useI18n();
  const search = useSearch({ from: activityRoute.id });
  return (
    <AuthPlaceholder
      title={t(msg`Activity`)}
      description={t(msg`Sign in to see who did what in your restaurant.`)}
    >
      <PageContainer maxWidth="3xl">
        <ActivityFeedPage initialSessionId={search().session} />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const activityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/activity",
  validateSearch: (search: Record<string, unknown>): ActivitySearch => ({
    session:
      typeof search.session === "string" && search.session.trim() !== ""
        ? search.session
        : undefined,
  }),
  component: ActivityRoutePage,
});
